import {
  formatDecimal,
  formatIndex,
  formatSimulationCalculatedIndex,
  round,
} from '@/components/table/table-format-helpers';
import type {
  SimulationIndexRow,
  SimulationIndexRowForDisplay,
} from '../../utils/simulation-index-types';

export const formatIndexRowForDisplay = (
  row: SimulationIndexRow,
): SimulationIndexRowForDisplay => ({
  priceList: row.priceList,
  currency: row.currency,
  rm: `${formatDecimal(row.rm, 1, true)}%`,
  rrpIndex: formatSimulationCalculatedIndex(row.rrpIndex),
  rrpLocalLeadExclVatIndex: formatSimulationCalculatedIndex(
    row.rrpLocalLeadExclVatIndex,
  ),
  lpLocalLeadIndex: formatSimulationCalculatedIndex(row.lpLocalLeadIndex),
  nipLocalLeadIndex: formatSimulationCalculatedIndex(row.nipLocalLeadIndex),
  nipGlobalLeadIndex: formatSimulationCalculatedIndex(row.nipGlobalLeadIndex),
  listPriceFmcFactorTarget: formatDecimal(
    row.listPriceFmcFactorTarget,
    3,
    true,
  ),
  listPriceFmcFactor: formatDecimal(row.listPriceFmcFactor, 3, true),
  listPriceFmcFactorDifference: `${formatDecimal(
    row.listPriceFmcFactorDifference,
    2,
    true,
  )}%`,
  salesRevenue: round(row.salesRevenue, 0).toLocaleString('da-DK'),
  productCount: round(row.productCount, 0).toLocaleString('da-DK'),
});
